// extracted by mini-css-extract-plugin
export var cardIcon = "_6l-5";
export var cardIconUnframed = "_6l-9";
export var checkboxCard = "_6l-0";
export var checkboxCardSelected = "_6l-4";
export var disabled = "_6l-2";
export var interactive = "_6l-1";
export var outerBorder = "_6l-3";
export var spacerMedium = "_6l-8";
export var spacerSmall = "_6l-7";
export var spacerXsmall = "_6l-6";